import {gql} from "@apollo/client";
import {Brand} from "types";

export interface BrandListQuery {
    brands: Brand[]
}

export const GET_BRAND_LIST = gql`
    query getBrandList {
        brands {
            id
            name
            icon
        }
    }
`;
